'use client';

import { swrConfig } from 'lib/fetchJson';
import type { ReactNode } from 'react';
import { SWRConfig } from 'swr';

export const SWRProvider = ({ children }: { children: ReactNode }) => {
  return <SWRConfig value={swrConfig}>{children}</SWRConfig>;
};
